import { hasExceededFailedThreshold } from './offlinePunchRetrySchedule';

export const RETRY_DISPLAY_MIN_MS = 5000;
export const SUBMIT_DISPLAY_MIN_MS = RETRY_DISPLAY_MIN_MS;

export const OFFLINE_PUNCH_DISPLAY_STATUS = Object.freeze({
  PENDING: 'pending',
  SUBMITTING: 'submitting',
  RETRYING: 'retrying',
  FAILED: 'failed',
});

export const getRetryDisplayUntil = (now = Date.now()) =>
  now + RETRY_DISPLAY_MIN_MS;

export const getSubmitDisplayUntil = (now = Date.now()) =>
  now + SUBMIT_DISPLAY_MIN_MS;

export const extendRetryDisplayUntil = (existingUntil, now = Date.now()) =>
  Math.max(existingUntil ?? 0, getRetryDisplayUntil(now));

export const getOfflinePunchDisplayStatus = (item, now = Date.now()) => {
  if (!item) {
    return OFFLINE_PUNCH_DISPLAY_STATUS.PENDING;
  }

  const {
    status,
    retryCount = 0,
    queuedAt,
    retryDisplayUntil,
    submitDisplayUntil,
  } = item;

  if (status === 'permanent_failure') {
    return OFFLINE_PUNCH_DISPLAY_STATUS.FAILED;
  }

  if (status === 'syncing') {
    return retryCount === 0
      ? OFFLINE_PUNCH_DISPLAY_STATUS.SUBMITTING
      : OFFLINE_PUNCH_DISPLAY_STATUS.RETRYING;
  }

  if (hasExceededFailedThreshold(queuedAt, now)) {
    return OFFLINE_PUNCH_DISPLAY_STATUS.FAILED;
  }

  if (retryCount > 0 && submitDisplayUntil > now) {
    return OFFLINE_PUNCH_DISPLAY_STATUS.SUBMITTING;
  }

  if (retryDisplayUntil > now && retryCount > 0) {
    return OFFLINE_PUNCH_DISPLAY_STATUS.RETRYING;
  }

  return OFFLINE_PUNCH_DISPLAY_STATUS.PENDING;
};

export const hasFailedOfflinePunch = (queue) =>
  queue.some(
    (item) =>
      getOfflinePunchDisplayStatus(item) === OFFLINE_PUNCH_DISPLAY_STATUS.FAILED
  );

export const getOfflinePunchDisplayStatusColor = (displayStatus, theme) => {
  switch (displayStatus) {
    case OFFLINE_PUNCH_DISPLAY_STATUS.SUBMITTING:
      return theme.palette.primary.main;
    case OFFLINE_PUNCH_DISPLAY_STATUS.RETRYING:
      return theme.palette.primary.light;
    case OFFLINE_PUNCH_DISPLAY_STATUS.FAILED:
      return theme.palette.error.main;
    case OFFLINE_PUNCH_DISPLAY_STATUS.PENDING:
    default:
      return theme.palette.text.secondary;
  }
};
